import {createAsyncThunk} from '@reduxjs/toolkit';

import {IDocJournalData} from 'components/widget/items/documents-publication-pie-chart/doc-journal-pie-chart';
import {INewsData} from 'components/widget/items/news/news';
import {ICorrNum, INobComponent} from 'components/widget/items/nob-components-bar-chart/nob-components-bar-chart';
import {IRequestsTableData} from 'components/widget/items/request-table/request-table';

import {
    TFetchDocJournalDataArgs,
    TFetchNobComponentsCorrNumListArgs,
    TFetchNobComponentsData,
    TFetchRequestsDataArgs,
    fetchDocJournalData,
    fetchNews,
    fetchNobComponentsCorrNumList,
    fetchNobComponentsData,
    fetchRequestsData,
} from './widgets-slice-api';
import {WIDGETS_SLICE} from './widgets-slice-constants';

export const loadRequestsData = createAsyncThunk<
    IRequestsTableData, TFetchRequestsDataArgs
    >(`${WIDGETS_SLICE}/loadRequestData`, async (args, {rejectWithValue}) => {
        try {
            const response = await fetchRequestsData(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    });

export const loadDocJournalData = createAsyncThunk<
    IDocJournalData[], TFetchDocJournalDataArgs
    >(`${WIDGETS_SLICE}/loadDocJournalData`, async (args, {rejectWithValue}) => {
        try {
            const response = await fetchDocJournalData(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    });

export const loadNobComponentsCorrNumList = createAsyncThunk<
    ICorrNum[], TFetchNobComponentsCorrNumListArgs
    >(`${WIDGETS_SLICE}/loadNobComponentsCorrNumList`, async (args, {rejectWithValue}) => {
        try {
            const response = await fetchNobComponentsCorrNumList(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    });

export const loadNobComponentsData = createAsyncThunk<
    INobComponent[], TFetchNobComponentsData
    >(`${WIDGETS_SLICE}/loadNobComponentsData`, async (args, {rejectWithValue}) => {
        try {
            const response = await fetchNobComponentsData(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    });

export const loadNews = createAsyncThunk<
    INewsData[], void
    >(`${WIDGETS_SLICE}/loadNews`, async (_, {rejectWithValue}) => {
        try {
            const response = await fetchNews();
            return response.data.dataTable;
        } catch (e) {
            return rejectWithValue(e);
        }
    });
